import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { WaterFactoryModel } from "@/core/models/water-factory.model";

interface _WaterFactoryGetParams {
    search?: string;
}

@injectable()
export class WaterFactoryRepo extends TableRepo<WaterFactoryModel> {

    private factoryCache = new Map<string, WaterFactoryModel>();

    constructor() {
        super("/api/WaterFactory");
    }

    async getData(index: number, params: _WaterFactoryGetParams, pageSize = 10): Promise<ApiPage<WaterFactoryModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    override async detail(id: string): Promise<WaterFactoryModel | null | undefined> {
        const cache = this.factoryCache.get(id);
        if (cache) return cache;
        const _factory = await super.detail(id);
        if (_factory) {
            this.factoryCache.set(id, _factory);
        }
        return _factory;
    }
}